import $ from "jquery";

const filtersFormLabels = $(".filter-form-select__brand");

function toggleFilters() {
  // Toggle dropdown list on click or Enter/Space key
  filtersFormLabels.on("click keydown", function (event) {
    if (event.type === "click" || event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const fieldsToggle = $(this).next(".filter-form-select__list");

      if (fieldsToggle.is(":visible")) {
        $(this).removeClass("opened");
        fieldsToggle.slideUp();
      } else {
        $(this).addClass("opened");
        fieldsToggle.slideDown();
      }
    }
  });

  // Update label text based on selected checkboxes
  $(".filter-form__checkbox").on("change", function () {
    // Find the parent container of the filter list
    const container = $(this).closest(".filter-form-select");
    const filterReset = $("#filter-reset");
    const filterSubmit = $(".resources-form-submit");
    filterReset.hide();
    filterSubmit.show();

    let selectedTexts = [];
    // Gather texts of all checked items
    container.find(".filter-form__checkbox:checked").each(function () {
      selectedTexts.push($(this).next("label").text());
    });

    // Join selected texts with commas
    let displayText = selectedTexts.join(", ");

    // Truncate if longer than 38 characters
    if (displayText.length > 38) {
      displayText = displayText.substring(0, 38) + "...";
    }

    // Update the filter label text with the selected options or the default text if none selected
    container
      .find(".filter-form-select__brand")
      .text(displayText || container.find(".filter-form-select__brand").data("default"));
  });

  // Store default text for each filter label
  filtersFormLabels.each(function () {
    $(this).data("default", $(this).text());
  });

  // Hide dropdown list if click occurs outside of it
  $(document).on("click", function (event) {
    if (!$(event.target).closest(".filter-form-select").length) {
      $(".filter-form-select__list").slideUp();
      filtersFormLabels.removeClass("opened");
    }
  });
}

// Initialize the toggle function
toggleFilters();

//add dataLayer
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector("#search-resource");
  const searchButton = document.querySelector(".resources-form-submit");

  function sendSearchEvent() {
    const searchTerm = searchInput.value.trim();
    if (searchTerm) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "search",
        search_term: searchTerm,
      });
    }
  }

  //click on Enter
  searchInput.addEventListener("keypress", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      sendSearchEvent();
    }
  });

  //click on Apply filters btn
  if (searchButton) {
    searchButton.addEventListener("click", function (event) {
      event.preventDefault();
      sendSearchEvent();
    });
  }
});
